import { REQUEST_PRODUCT_MANIFEST, RECEIVE_PRODUCT_MANIFEST, ERROR_PRODUCT_MANIFEST } from '../actions/productManifestActions';
var initialState = {
  manifest: {},
  fetching: true,
  error: {}
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case REQUEST_PRODUCT_MANIFEST:
      return Object.assign({}, state, {
        fetching: true
      });
    case RECEIVE_PRODUCT_MANIFEST:
      return Object.assign({}, state, {
        manifest: payload,
        fetching: false
      });
    case ERROR_PRODUCT_MANIFEST:
      return Object.assign({}, state, {
        fetching: false,
        error: payload
      });
    default:
      return state;
  }
});